import { PropertyDefinitionConfig } from '../types';

/** Pseudo-repository metadata for anchor UI labels. */
export const ANCHOR_REPOSITORY: PropertyDefinitionConfig = {
	id: 'idAnchorRepository',
	singular: 'Anchor',
};
